/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 * Currently disabled since we don't do any translations.
 */
// import '@angular/localize/init';

// This file includes polyfills needed by Angular and is loaded before
// the app. You can add your own extra polyfills to this file.

import 'zone.js';
